<!-- 角色管理 -->
<template>
    <div class="container">
        <div class="content">
            <div>
                <Button class="theme-bg mb-24" type="warning" @click="goModal">新增角色</Button>
                <Table ref="selection" :columns="columnsTable" :data="dataTable" border @on-selection-change="changeSelection">
                    <template slot-scope="{ index }" slot="id">
                        <div>{{ index + 1 }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="primary" ghost label="small" @click="goModal(row)">编辑</Button>
                            <Button type="error" ghost label="small"  @click="goDel(1, row)">删除</Button>
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <div>
                    <Checkbox class="checkbox-ml" v-model="del_value" @on-change="handleSelectAll">全选</Checkbox>
                    <span class="mr-24 ml-24">已经选择{{delData.length}}个</span>
                    <Button type="error" ghost label="large" @click="goDel(0)">删除</Button>
                </div>
                <Page :current="storePrams.page" :page-size="storePrams.limit" :total="total" show-elevator show-total @on-change="pageChange"/>
            </div>
        </div>
        <!-- 新增角色 -->
        <Modal v-model="modals" :title="modalTitle" width="700" :mask-closable="false">
            <div>
                <Form ref="formData" :model="formData" :rules="ruleValidate" label-position="right" :label-width="100">
                    <FormItem label="角色名称：" prop="title">
                        <Input class="width_80" type="text" v-model="formData.title" placeholder="请输入角色名称"></Input>
                    </FormItem>
                    <FormItem label="菜单权限：" prop="pc_rules">
                        <div class="tree-div">
                            <div>
                                <div>PC端权限</div>
                                <Tree :data="treeData1" show-checkbox multiple expand-node @on-check-change='changeTree1'></Tree>
                            </div>
                            <div class="tree-border"></div>
                            <div>
                                <div>H5权限</div>
                                <Tree :data="treeData2" show-checkbox multiple expand-node @on-check-change='changeTree2'></Tree>
                            </div>
                        </div>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelForm">取消</Button>
                <Button class="theme-bg ml-24" type="warning" @click="submitForm">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import { 
    account_roles_list, 
    account_roles_create, 
    account_roles_info, 
    account_roles_menus, 
    account_roles_delete,
} from '@/api/index';
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 10,
            },
            total: 0,
            columnsTable: [
                { type: 'selection', width: 50, align: 'center' },
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "角色名称", key: "title", align: "center" },
                { title: "创建时间", key: "created_at", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "200px" },
            ],
            dataTable: [],
            modals: false,
            modalTitle: "",
            formData: {
                id: "",
                title: "",
                pc_rules: [],
                h5_rules: [],
            },
            // selection
            del_id: "",
            delData: [],
            del_value: false,
            ruleValidate: {
                title: [
                    { required: true, message: '请输入角色名称', trigger: 'blur' }
                ],
                rules: [
                    { required: true, message: '请选择菜单权限', trigger: 'blur' }
                ],
            },
            pcData: [],
            h5Data: [],
            treeData1: [],
            treeData2: [],
        };
    },
    mounted() {
        this.getList();
        this.getAccountRolesMenus();
    },
    methods: {
        getList(){
            account_roles_list(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        pageChange(index){
            this.storePrams.page = index;
            this.getList();
        },
        // 角色详情
        getAccountRolesInfo(){
            account_roles_info({ id: this.formData.id}).then((res) => {
                this.formData.pc_rules = res.data.pc_rules;
                this.formData.h5_rules = res.data.h5_rules;
                this.changeData();
                let data1 = res.data.pc_rules;
                let selectId1 = '';
                data1.forEach(item => {
                    selectId1 += item;
                    selectId1 += ',';
                })
                selectId1 = selectId1.slice(0, -1);
                this.formData.pc_rules = selectId1;

                let data2 = res.data.h5_rules;
                let selectId2 = '';
                data2.forEach(item => {
                    selectId2 += item;
                    selectId2 += ',';
                })
                selectId2 = selectId2.slice(0, -1);
                this.formData.h5_rules = selectId2;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        changeTree1(e,i){
            this.$forceUpdate();
            let data = e;
            let selectId = '';
            data.forEach(item => {
                selectId += item.id;
                selectId += ',';
            })
            selectId = selectId.slice(0, -1);
            this.formData.pc_rules = selectId;
        },
        changeTree2(e,i){
            this.$forceUpdate();
            let data = e;
            let selectId = '';
            data.forEach(item => {
                selectId += item.id;
                selectId += ',';
            })
            selectId = selectId.slice(0, -1);
            this.formData.h5_rules = selectId;
        },
        // 所有菜单
        getAccountRolesMenus(){
            account_roles_menus().then( res => {
                this.pcData = res.data.pc;
                this.h5Data = res.data.h5;
            }).catch(res=>{
                this.$Message.error(res.msg);
            })
        },
        changeData(){
            let data1 = this.pcData;
            data1.forEach(item => {
                if(this.formData.pc_rules.indexOf((item.id+''))!==-1){                        
                    item.checked = true;
                }else {                        
                    item.checked = false;
                }
                if(item.children){
                    item.expand = false;
                    item.children.forEach(itm =>{
                        if(this.formData.pc_rules.indexOf((itm.id+''))!==-1){                        
                            itm.checked = true;
                        }else {                        
                            itm.checked = false;
                        }
                    })     
                }
            });  
            this.treeData1 =JSON.parse(JSON.stringify(data1));

            let data2 = this.h5Data;
            data2.forEach(item => {
                if(this.formData.h5_rules.indexOf((item.id+''))!==-1){                        
                    item.checked = true;
                }else {                        
                    item.checked = false;
                }
                if(item.children){
                    item.expand = false;
                    item.children.forEach(itm =>{
                        if(this.formData.h5_rules.indexOf((itm.id+''))!==-1){                        
                            itm.checked = true;
                        }else {                        
                            itm.checked = false;
                        }
                    })     
                }
            });  
            this.treeData2 =JSON.parse(JSON.stringify(data2));
        },
        // Modal
        goModal(row){
            if(row.id){
                this.modalTitle = "编辑角色";
                this.formData.id = row.id;
                this.formData.title = row.title;
                this.getAccountRolesInfo();
            }else {
                this.modalTitle = "新增角色";
                this.formData.id = "";
                this.formData.title = "";
                this.formData.pc_rules = [];
                this.formData.h5_rules = [];
                this.changeData();
            }
            setTimeout(() => {
                this.modals = true;
            }, 300);
        },
        cancelForm(){
            this.modals = false;
        },
        // 确定（提交表单）
        submitForm(){
            if(this.formData.pc_rules.length){
                this.formData.pc_rules = this.formData.pc_rules.split(',');
            }
            if(this.formData.h5_rules.length){
                this.formData.h5_rules = this.formData.h5_rules.split(',');
            }
            account_roles_create(this.formData).then( res => {
                this.getList();
                this.modals = false;
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            }) 
        },
        // selection
        changeSelection(e){
            this.delData = e;
            if(this.dataTable.length === e.length){
                this.del_value = true;
            }else{
                this.del_value = false;
            }
        },
        handleSelectAll(e){
            if(e == true){
                this.delData = this.dataTable;
                this.$refs.selection.selectAll(true);
            }else{
                this.$refs.selection.selectAll(false);
            }
        },
        goDel(index, row){
            if(index == 0 && this.delData.length == 0){
                this.$Message.error('请选择');
                return
            }
            let that = this;
            this.$Modal.confirm({
                title: '删除提示',
                content: '确认删除吗？一经删除无法复原',
                onOk: () => {
                    if(index == 0){
                        var del_id = [];
                        this.delData.forEach(item => {
                            del_id.push(item.id)
                        });
                        this.del_id = del_id.join(',');
                        account_roles_delete({ id: this.del_id }).then(res=>{
                            that.getList();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }else if(index == 1){
                        account_roles_delete({ id:row.id }).then(res=>{
                            that.getList();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }
                },
                onCancel: () => {
                }
            }); 
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.page {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
}
.footer {
    position: absolute;
    right: 20px;
    bottom: 20px;
}
::v-deep .ivu-tree ul li {
    margin: 0;
    padding: 0;
    list-style: none;
    white-space: nowrap;
    outline: 0;
}
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #53C41A;
    border-color: #53C41A;
    box-shadow: -1px 0 0 0 #53C41A;
    border-radius: 5px;
    color: #fff;
    z-index: 1;
}
::v-deep .ivu-checkbox{
    margin-right: 12px;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.width_80 {
    width: 80%;
}
.tree-div {
    width: 80%;
    display: flex;
    justify-content: space-between;
}
.tree-border {
    margin: auto 0;
    width: 1px;
    height: 100px;
    background-color: #cccccc;
    height: 20vh;
}
</style>